import React from 'react';
import { Spin } from 'antd';

function Loading({ fullPage = false, flex = false }) {
  return (
    <div
      className={`loading-container ${fullPage ? 'full-page' : ''} ${flex ? 'flex-loading' : ''}`}>
      <Spin size="large" />
    </div>
  );
}

export default Loading;
